const accordionElements = document.querySelectorAll('.js-accordion');

accordionElements.forEach((accordionElement) => {
  accordionElement.classList.add('is-enabled');

  const itemElements = accordionElement.querySelectorAll('.js-accordion-item');

  itemElements.forEach((item, index) => {
    const button = item.querySelector('.js-accordion-button');
    const wrap = item.querySelector('.js-accordion-wrap');
    const contentEl = item.querySelector('.js-accordion-content');

    // Generate unique IDs for ARIA attributes
    const accordionId = `accordion-${Math.random().toString(36).substr(2, 9)}`;
    const panelId = `${accordionId}-panel-${index}`;
    const buttonId = `${accordionId}-button-${index}`;

    // Set up ARIA attributes
    button.setAttribute('id', buttonId);
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', panelId);

    wrap.setAttribute('id', panelId);
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('aria-labelledby', buttonId);

    button.addEventListener('click', (e) => {
      const isExpanded = item.classList.contains('is-expanded');
      item.classList.toggle('is-expanded');

      let height = contentEl.getBoundingClientRect().height;

      // IE11
      if (height == 0) {
        height = contentEl.clientHeight;
      }

      if (!isExpanded) {
        wrap.style.height = height + 'px';
        button.setAttribute('aria-expanded', 'true');
      } else {
        wrap.style.height = 0;
        button.setAttribute('aria-expanded', 'false');
      }
    });
  });
});
